import React from 'react';
// import DashboardLayout from '../components/Layouts/DashboardLayout';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import SellerBidList from '../components/DashboardComponents/SellerBidList';
const SellerBid = () => {
 return (
    <>
<InnerBanner pageKey="sellerBid" />

      <section className='dashboard'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                   <SellerBidList/> 
                </div>
            </div>
        </div>
      </section>
    </>
 );

};

export default SellerBid;